import React, { useState, useEffect } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Recipe } from "ceicons";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import { ImageDropzone } from "../../ImageDropzone";
import environment from "../../../environment";
import { createFragmentContainer } from "react-relay";
import { useTranslation } from "ceco-polyglot";
import { isEmpty } from "lodash";

import "./stepRecipeModal.scss";

function StepRecipeModal(props) {
  const {
    trigger,
    title,
    edit,
    recipeId,
    allWarnings: { edges },
    configConstance,
    steps,
    isDragging,
    refetchData,
    summaryIngredient,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [file, setFile] = useState();
  const [fileError, setFileError] = useState();
  const [formData, setFormData] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [ingredientsList, setIngredientsList] = useState();

  useEffect(() => {
    if (summaryIngredient) {
      setIngredientsList(
        summaryIngredient.edges.map((ingredient) => {
          return {
            key: ingredient.node.ingredient.id,
            text: ingredient.node.ingredient.name,
            value: ingredient.node.ingredient.id,
          };
        })
      );
    }
  }, [summaryIngredient]);

  const alerts = edges.map((alert) => {
    const {
      node: { id, slugName },
    } = alert;
    return {
      key: id,
      text: slugName,
      value: id,
    };
  });

  const t = useTranslation();
  function addStepToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = formData.isRobot
        ? { ...formData, recipe: recipeId }
        : {
            ...formData,
            recipe: recipeId,
            speed: 0,
            temperatureControl: 0,
            temperatureDegrees: 0,
            warning: "",
          };
      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }

      commitMutation(environment, {
        mutation: StepRecipeModalCreate_Mutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function editStepToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = formData.isRobot
        ? { ...formData, recipe: recipeId }
        : {
            ...formData,
            recipe: recipeId,
            speed: 0,
            temperatureControl: 0,
            temperatureDegrees: 0,
            warning: "",
          };
      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }

      commitMutation(environment, {
        mutation: StepRecipeModalUpdate_Mutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const handleChangeIsRobot = (e, { checked }) => {
    setFormData({
      ...formData,
      isRobot: checked,
    });
  };

  const handleChangeTurbo = (e, { checked }) => {
    setFormData({
      ...formData,
      turbo: checked,
    });
  };

  const handleChangeAlert = (e, { value }) => {
    setFormData({
      ...formData,
      warning: value,
    });
  };

  function handleChangeFloat(evt) {
    const { value, name } = evt.target;
    setFormData({
      ...formData,
      [name]: parseFloat(value),
    });
  }

  function handleChangeInt(evt) {
    const { value, name } = evt.target;

    setFormData({
      ...formData,
      [name]: parseInt(value),
    });
  }

  const handleChangeIng = (e, { value }) => {
    setFormData({
      ...formData,
      ingredient: value,
    });
  };

  const handleChangeUnit = (e, { value }) => {
    setFormData({
      ...formData,
      unit: value,
    });
  };

  function handleChange(evt) {
    const { value, name } = evt.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  const onSubmit = async () => {
    if (validateForm()) {
      isDragging.current = false;
      const action = !edit ? addStepToRecipe : editStepToRecipe;
      const msg = !edit ? t("message.added_step") : t("message.edited_step");

      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.description) {
      errors = { ...errors, description: t("form.errorRequired") };
    }

    if (formData.ingredient) {
      if (!formData.weight) {
        errors = { ...errors, weigth: t("form.errorMesaggeStepWeigth") };
      }
    }

    if (formData.weight) {
      if (!formData.ingredient) {
        errors = {
          ...errors,
          ingredient: t("form.errorMesaggeStepIngredient"),
        };
      }
    }

    if (formData.isRobot) {
      if (
        isNaN(formData.temperatureDegrees) ||
        formData.temperatureDegrees < 37 ||
        formData.temperatureDegrees > 120
      ) {
        if (formData.temperatureDegrees !== 0) {
          errors = {
            ...errors,
            temperatureDegrees: t("form.errorMessageStepTemp"),
          };
        }
      } else {
        if (!formData.temperatureControl) {
          errors = {
            ...errors,
            temperatureControl: t("form.errorTemperaturaDegress"),
          };
        }
      }

      if (formData.speed < 0 || formData.speed > 10 || isNaN(formData.speed)) {
        errors = { ...errors, speed: t("form.errorMessageStepSpeed") };
      }

      if (formData.temperatureControl) {
        if (!formData.temperatureDegrees) {
          errors = {
            ...errors,
            temperatureDegrees: t("form.errorMessageStepCtrlTemp"),
          };
        }
      }
    }

    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="small"
      className="step-modal single-button"
      title={
        edit ? (
          <div className="modalTitle">
            <Recipe />
            {t("modalTitle.editStep")}
          </div>
        ) : (
          title || (
            <div className="modalTitle">
              <Recipe />
              {t("modalTitle.addStep")}
            </div>
          )
        )
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit
            ? setFormData({
                ...steps?.node,
                warning: steps?.node?.warning?.edges[0]?.node?.id,
                ingredient: steps?.node?.ingredient?.id,
              })
            : setFormData({
                isRobot: false,
                turbo: false,
                unit: "g",
                time: "00:00:00",
              });

          setFile();
        },
      })}
      actions={
        <Button
          type="submit"
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("form.addImage")}</label>
            <ImageDropzone
              file={file}
              setFile={setFile}
              fileError={fileError}
              setFileError={setFileError}
              imgLoaded={edit && formData?.media}
            />
          </Form.Field>
          <Form.Field>
            <Form.TextArea
              className="form-description"
              onChange={handleChange}
              label={t("form.description")}
              error={formErrors && formErrors["description"]}
              defaultValue={formData?.description}
              name="description"
              required
            />
          </Form.Field>
        </Form.Group>

        <Form.Group className="form-row-two" widths={3}>
          <Form.Input
            name="time"
            type="time"
            transparent
            step={1}
            defaultValue={formData?.time || "00:00:00"}
            label={t("form.time")}
            placeholder={t("form.time")}
            onChange={handleChange}
          />
          <Form.Input
            disabled={!formData?.isRobot}
            name="speed"
            type="number"
            icon={false}
            transparent
            max={configConstance.speedLimit}
            error={formErrors && formErrors["speed"]}
            defaultValue={`${formData?.speed}` || ""}
            label={t("form.speed")}
            placeholder="00"
            onChange={handleChangeInt}
            required
          />
          <Form.Input
            disabled={!formData?.isRobot}
            name="temperatureDegrees"
            type="number"
            transparent
            max={configConstance.temperatureDegreesMax}
            min={configConstance.temperatureDegreesMin}
            error={formErrors && formErrors["temperatureDegrees"]}
            defaultValue={`${formData?.temperatureDegrees}` || ""}
            label={t("form.temperatureDegrees")}
            placeholder="000"
            onChange={handleChangeInt}
            required
          />
          <Form.Input
            disabled={!formData?.isRobot}
            name="temperatureControl"
            type="number"
            transparent
            max={configConstance.temperatureControlLimit}
            error={formErrors && formErrors["temperatureControl"]}
            defaultValue={`${formData?.temperatureControl}` || ""}
            label={t("form.temperatureControl")}
            placeholder="00"
            onChange={handleChangeInt}
            required
          />
        </Form.Group>

        <Form.Group className="form-row-three" widths={3}>
          <Form.Dropdown
            placeholder={t("form.alert")}
            label={t("form.alert")}
            name="warning"
            error={formErrors && formErrors["warning"]}
            search
            onChange={handleChangeAlert}
            defaultValue={steps?.node?.warning?.edges[0]?.node?.id || ""}
            noResultsMessage={t("message.noResultsAlerts")}
            selection
            clearable
            options={alerts}
            disabled={!formData?.isRobot}
          />

          <Form.Checkbox
            toggle
            onChange={handleChangeIsRobot}
            name="isRobot"
            checked={formData?.isRobot}
            label={t("form.isRobot")}
          />

          <Form.Checkbox
            toggle
            defaultChecked={false}
            onChange={handleChangeTurbo}
            name="turbo"
            checked={formData?.turbo}
            label={t("form.turbo")}
          />
        </Form.Group>
        <Form.Group className="form-row-four" widths={1}>
          <Form.Field>
            <Form.TextArea
              onChange={handleChange}
              label={t("form.waitingInstructions")}
              name="waitingInstructions"
              defaultValue={formData?.waitingInstructions || ""}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group className="form-row-five" widths={3}>
          <Form.Input
            name="weight"
            type="number"
            transparent
            error={formErrors && formErrors["weigth"]}
            defaultValue={formData?.weight || ""}
            label={t("form.weight")}
            placeholder="00"
            onChange={handleChangeFloat}
          />
          <Form.Dropdown
            placeholder={t("form.unit")}
            label={t("form.unit")}
            name="unit"
            search
            onChange={handleChangeUnit}
            defaultValue={formData?.unit}
            noResultsMessage={t("message.noResultsUnits")}
            selection
            options={[
              { key: "g", text: "g", value: "g" },
              { key: "l", text: "l", value: "l" },
            ]}
          />
          <Form.Dropdown
            placeholder={t("form.ingredient")}
            label={t("form.ingredient")}
            name="ingredient"
            error={formErrors && formErrors["ingredient"]}
            search
            onChange={handleChangeIng}
            defaultValue={formData?.ingredient}
            noResultsMessage={t("message.noResultsIngredients")}
            selection
            options={ingredientsList}
            clearable
          />
        </Form.Group>
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}

const StepRecipeModalCreate_Mutation = graphql`
  mutation StepRecipeModalCreateMutation(
    $recipe: ID!
    # $prevStep: ID
    # $nextStep: ID
    $description: String
    $time: Time
    $speed: Int
    $temperatureDegrees: Int
    $temperatureControl: Int
    $turbo: Boolean
    $waitingInstructions: String
    $warning: ID
    $isRobot: Boolean
    $ingredient: ID
    $weight: String
    $unit: String
  ) {
    recipeStepCreate(
      input: {
        recipe: $recipe
        # prevStep: $prevStep
        # nextStep: $nextStep
        description: $description
        time: $time
        speed: $speed
        temperatureDegrees: $temperatureDegrees
        temperatureControl: $temperatureControl
        turbo: $turbo
        waitingInstructions: $waitingInstructions
        warning: $warning
        isRobot: $isRobot
        ingredient: $ingredient
        weight: $weight
        unit: $unit
      }
    ) {
      recipeStep {
        id
        description
        media
      }
    }
  }
`;

const StepRecipeModalUpdate_Mutation = graphql`
  mutation StepRecipeModalUpdateMutation(
    $id: ID!
    # $prevStep: ID
    # $nextStep: ID
    $description: String
    $time: Time
    $speed: Int
    $temperatureDegrees: Int
    $temperatureControl: Int
    $turbo: Boolean
    $waitingInstructions: String
    $warning: ID
    $isRobot: Boolean
    $ingredient: ID
    $weight: String
    $unit: String
  ) {
    recipeStepUpdate(
      input: {
        id: $id
        # prevStep: $prevStep
        # nextStep: $nextStep
        description: $description
        time: $time
        speed: $speed
        temperatureDegrees: $temperatureDegrees
        temperatureControl: $temperatureControl
        turbo: $turbo
        waitingInstructions: $waitingInstructions
        warning: $warning
        isRobot: $isRobot
        ingredient: $ingredient
        weight: $weight
        unit: $unit
      }
    ) {
      recipeStep {
        id
        description
        media
      }
    }
  }
`;

export default createFragmentContainer(StepRecipeModal, {
  allWarnings: graphql`
    fragment StepRecipeModal_allWarnings on WarningNodeConnection {
      edges {
        node {
          id
          slugName
        }
      }
    }
  `,
  configConstance: graphql`
    fragment StepRecipeModal_configConstance on ConfigConstance {
      speedLimit
      temperatureControlLimit
      temperatureDegreesMin
      temperatureDegreesMax
    }
  `,
  summaryIngredient: graphql`
    fragment StepRecipeModal_summaryIngredient on RecipeIngredientNodeConnection {
      edges {
        node {
          ingredient {
            id
            name
          }
        }
      }
    }
  `,
});
